<template>
  <div class="inner-main">

    <div class="div-top">
      <i class="iconfont iconCommunity"
        style="font-size: 0.875rem; color: #d04a02"></i>
      <van-dropdown-menu>
        <van-dropdown-item v-model="order"
          :options="orderOptions" />
      </van-dropdown-menu>
      <div id="org-invested-filter"
        class="filter"
        @click="showSearch">
        <span>{{ $t("common.filter") }} </span>
        <i class="iconfont iconfilter-outline"></i>
      </div>

      <van-popup v-model="showSearchPanel"
        position="right"
        :style="{ height: '100%', width: '85%' }">
        <search-panel :type="searchPanelType"
          @search="searchByPanel"></search-panel>
      </van-popup>
    </div>

    <van-list v-model="loading"
      :finished="finished"
      finished-text="没有更多了"
      @load="onLoad"
      :immediate-check="false">

      <div class="item"
        v-for="data in list"
        :key="data.fundId">

        <div class="item-main"
          @click="goDetail(data.id)">
          <div class="item-img">
            <van-image width="4rem"
              height="4rem"
              :src="data.originalLogo" />
          </div>
          <div class="item-info">
            <div class="item-head">
              <div class="head-name"
                v-text="data.name"></div>
            </div>
            <div class="item-prefer">

              <!-- <span>FundingDate</span><span>{{ data.fundingDate }}</span> -->
              <span>当前轮次：</span><span>{{ data.fundingRound }}</span>
            </div>
            <div class="tags">
              <!-- {{data.introduction}} -->
              <van-tag v-for="industry in getField(data.industryField)"
                :key="industry"
                plain
                type="primary"
                class="my-tag">
                {{ industry }}
              </van-tag>
            </div>
          </div>
        </div>
      </div>
    </van-list>

  </div>
</template>

<script>
import common from "@common/common";
import formatter from "@common/formatter";
import webService from "@network/webService";
import SearchPanel from "@components/common/SearchPanel";

export default {
  data () {
    return {
      order: 0,
      orderOptions: [
        {
          text: "按最新融资时间排序",
          value: 0,
        },
      ],
      searchPanelType: common.searchTypeEnum.orgInvestedCompany,
      showSearchPanel: false,
      list: [],
      loading: false,
      finished: false,
      currentPage: 0,
      flag: false,
      industryNames: [],
      searchValue: "",
    };
  },
  props: {
    relatedId: {
      type: String,
      default: "",
    },
  },
  components: {
    SearchPanel,
  },

  computed: {},

  mounted () {
    // this.requestPageData();
    if (!this.flag) {
      this.flag = true;
      this.requestPageData();
    }
    console.log("mounted company...");
  },
  activated () { },

  methods: {
    nextPage () {
      if (!this.flag) {
        this.flag = true;
        console.log(this.flag);
        this.requestPageData();
      }
    },
    onLoad () {
      this.requestPageData();
    },
    requestPageData (isAdd) {
      let searchModel = {
        PageSize: 10,
        Page: this.currentPage,
        InvestorId: this.relatedId,
        IndustryNames:
          this.industryNames == null ? [] : this.industryNames,
        Search: this.searchValue,
      };
      webService.GetInvestedCompanyList(searchModel).then((res) => {
        console.log(res);
        this.flag = false;
        common.procssData(this, res.data, isAdd);
      });
    },
    formatDate (val) {
      return formatter.formatDate(val);
    },
    getField (industryField) {
      if (industryField) {
        return _.split(industryField, ",", 2);
      } else {
        return [];
      }
    },
    getDate (date) {
      if (!common.isEmpty(date)) {
        return this.$moment(date).format("yyyy/MM/DD");
      } else {
        return "None";
      }
    },
    goDetail (id) {
      this.$router.push({
        path: "/investedDetail/" + Math.random() * 1000000,
        query: {
          id: id,
        },
      });
    },
    showSearch () {
      this.showSearchPanel = true;
    },
    searchByPanel (searchParams) {
      if (searchParams.hasFilter) {
        document
          .getElementById("org-invested-filter")
          .classList.add("has-filter");
      } else {
        document
          .getElementById("org-invested-filter")
          .classList.remove("has-filter");
      }
      this.currentPage = 0;
      console.log(searchParams);

      this.list = [];
      this.showSearchPanel = false;
      this.industryNames = searchParams.IndustryNames;
      this.requestPageData();
      // this.list = [];
      // if (this.searchPanelType == common.searchTypeEnum.contractor) {
      //   this.oldSearchModel.SearchType =
      //     common.relationshipSearchTypeEnum.PEContact;
      //   this.oldSearchModel.ResponsibilityIds =
      //     searchParams.ResponsibilityIds;
      //   this.oldSearchModel.TitleIds = searchParams.TitleIds;
      //   this.oldSearchModel.RelationDeepthIds =
      //     searchParams.RelationDeepthIds;
      // }
      // this.showSearchPanel = false;
      // console.log(searchParams);
      // this.requestPageData();
    },
    search (searchValue) {
      this.searchValue = searchValue;
      this.currentPage = 0;
      this.requestPageData(false);
    },
  },
};
</script>
<style lang='less' scoped>
.inner-main {
  padding: 1.125rem;
}

.div-top {
  display: flex;
  align-items: center;
  height: 2.875rem;
  /deep/ .van-dropdown-menu__bar {
    box-shadow: none;
  }
  .org-name {
    flex: 2;
    font-size: 14px;
    font-weight: bolder;
    color: #464646;
  }
  .filter {
    text-align: right;
    flex: 1;
    //margin-right: -1rem;

    span {
      font-size: 0.875rem;
    }
    img {
      width: 1.25rem;
      vertical-align: middle;
    }
  }
}

.item:not(:nth-of-type(1)) {
  padding-top: 20px;
}
.item {
  .item-main {
    display: flex;
    border-bottom: 1px solid #f2f2f2;

    .item-img {
      padding: 0.25rem;
    }

    .item-info {
      padding: 0.25rem;
      flex: 1;
      position: relative;
      width: 100%;
      .item-head {
        display: flex;
        .head-name {
          color: #2d2d2d;
          font-size: 14px;
          font-weight: bolder;
          width: 70%;
        }
      }
      .item-prefer {
        padding: 0.3rem 0;
        font-size: 0.75rem;
        color: #7d7d7d;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        width: 75%;
      }

      .div-chk {
        position: absolute;
        right: 0;
        top: 50%;
        transform: translateY(-50%);
      }
    }
  }

  .tags {
    .my-tag {
      background-color: #f7f7f7;
      color: #464646;
      padding: 4px;
      margin: 0px 5px 0px 0px;
      font-size: 0.75rem;
    }

    .my-tag::before {
      border: none;
    }
  }

  .title {
    font-size: 16px;
    font-weight: 550;
    color: #464646;
    // height: 38px;
    line-height: 30px;
  }
  .round {
    font-size: 13px;
    line-height: 34px;
    padding-top: 10px;
    color: #464646;
  }
  .content {
    padding-top: 2px;
    font-size: 14px;
    line-height: 20px;
    color: #7d7d7d;

    text-overflow: -o-ellipsis-lastline;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 3;
    line-clamp: 3;
    -webkit-box-orient: vertical;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/content/org/OrgInvested.vue